var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{staticStyle:{"max-width":"700px"},attrs:{"id":"sidebarViewer","menu":_vm.menu,"theme":_vm.theme}},[_c('span',{attrs:{"slot":"toggle-icon"},slot:"toggle-icon"},[_vm._v("Réduire/Agrandir")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe6e6992","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/sideBarMapComment/SideBarMapComment.vue
// module id = 1109
// module chunks = 0